/** IACR's database ID is discovered from the authoritative source-access RPC. */
export type SourceId = number;
export type PickerSource = { id: number; name: string; displayName: string; requiredFeature?: string };
export const SOURCES: Record<number, PickerSource> = {
    1: { id: 1, name: 'arXiv', displayName: 'arXiv' },
    2: { id: 2, name: 'medRxiv', displayName: 'medRxiv' },
    3: { id: 3, name: 'bioRxiv', displayName: 'bioRxiv' },
    4: { id: 4, name: 'ChinaXiv', displayName: 'ChinaXiv' },
    5: { id: 5, name: 'PubMed', displayName: 'PubMed', requiredFeature: 'pubmed_source_access' },
    6: { id: 6, name: 'ChemRxiv', displayName: 'ChemRxiv' },
};

type SourceDecision = { sourceId: number; sourceName: string; isActive: boolean; allowed: boolean };
export function getPickerSources(decisions: SourceDecision[]): Record<number, PickerSource> {
    const sources = { ...SOURCES };
    const iacr = decisions.find(item => item.sourceName.toLowerCase() === 'iacr');
    if (iacr && iacr.isActive && iacr.allowed && Number.isInteger(iacr.sourceId) && iacr.sourceId > 0 && !sources[iacr.sourceId]) {
        sources[iacr.sourceId] = { id: iacr.sourceId, name: 'iacr', displayName: 'IACR ePrint' };
    }
    return sources;
}
